// extracted by mini-css-extract-plugin
export default {"container":"ContainerReport_container__tO6yt","column":"ContainerReport_column__UCtjM"};